module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('title', [_vm._v("Twirl")]), _c('link', {
    attrs: {
      "href": "default.css",
      "rel": "stylesheet",
      "type": "text/css"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "cta1",
    attrs: {
      "id": "p0005-01-0"
    }
  }, [_c('a', {
    attrs: {
      "id": "pagev"
    }
  }, [_vm._v("contents")])]), _c('a', {
    attrs: {
      "id": "pagev"
    }
  }), _c('p', {
    staticClass: "cct1",
    attrs: {
      "id": "p0005-02-1"
    }
  }, [_c('a', {
    attrs: {
      "id": "pagev"
    }
  }), _c('a', {
    attrs: {
      "href": "#/chapter2#ctn_1a",
      "id": "cnt_1a"
    }
  }, [_c('i', [_vm._v("Introduction")])])]), _vm._v(" "), _c('p', {
    staticClass: "cct2",
    attrs: {
      "id": "p0005-P-1"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/chapter3#ctn_1",
      "id": "cnt_1"
    }
  }, [_vm._v("1. More")])]), _vm._v(" "), _c('p', {
    staticClass: "cct2",
    attrs: {
      "id": "p0005-P-2"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter4#ctn_2",
      "id": "cnt_2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2. Yes")])]), _vm._v(" "), _c('p', {
    staticClass: "cct2",
    attrs: {
      "id": "p0005-P-3"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter5#ctn_3",
      "id": "cnt_3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3. Bloom")])]), _vm._v(" "), _c('p', {
    staticClass: "cct2",
    attrs: {
      "id": "p0005-P-4"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter6#ctn_4",
      "id": "cnt_4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4. Decorate")])]), _vm._v(" "), _c('p', {
    staticClass: "cct2",
    attrs: {
      "id": "p0005-P-5"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter7#ctn_5",
      "id": "cnt_5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5. Read")])]), _vm._v(" "), _c('p', {
    staticClass: "cct2",
    attrs: {
      "id": "p0005-P-6"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter8#ctn_6",
      "id": "cnt_6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6. Rest")])]), _vm._v(" "), _c('p', {
    staticClass: "cct2",
    attrs: {
      "id": "p0005-P-7"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter9#ctn_7",
      "id": "cnt_7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7. Wings")])]), _vm._v(" "), _c('p', {
    staticClass: "cct2",
    attrs: {
      "id": "p0005-P-8"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter10#ctn_8",
      "id": "cnt_8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8. Laugh")])]), _vm._v(" "), _c('p', {
    staticClass: "cct2",
    attrs: {
      "id": "p0005-P-9"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter11#ctn_9",
      "id": "cnt_9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9. Ponder")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "p0005-P-10"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter12#ctn_10",
      "id": "cnt_10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10. Pen")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "p0005-P-11"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter13#ctn_11",
      "id": "cnt_11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("11. Art")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "p0005-P-12"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter14#ctn_12",
      "id": "cnt_12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("12. Snap")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "p0005-P-13"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter15#ctn_13",
      "id": "cnt_13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("13. Verily")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "p0005-P-14"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter16#ctn_14",
      "id": "cnt_14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("14. Dance")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "p0005-P-15"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter17#ctn_15",
      "id": "cnt_15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("15. Fragrance")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "p0005-P-16"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter18#ctn_16",
      "id": "cnt_16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("16. Brave")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "p0005-03-2"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter19#ctn_17",
      "id": "cnt_17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("17. Sorrow")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "p0005-P-17"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter20#ctn_18",
      "id": "cnt_18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("18. Bubbles")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "p0005-P-18"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter21#ctn_19",
      "id": "cnt_19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("19. Evergreen")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "p0005-P-19"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter22#ctn_20",
      "id": "cnt_20",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("20. Sparrow")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "p0005-P-20"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter23#ctn_21",
      "id": "cnt_21",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("21. Be")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "p0005-P-21"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter24#ctn_22",
      "id": "cnt_22",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("22. Cuddle")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "p0005-P-22"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter25#ctn_23",
      "id": "cnt_23",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("23. Verve")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "p0005-P-23"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter26#ctn_24",
      "id": "cnt_24",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("24. Stars")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "p0005-P-24"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter27#ctn_25",
      "id": "cnt_25",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("25. Edit")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "p0005-P-25"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter28#ctn_26",
      "id": "cnt_26",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("26. Story")])]), _vm._v(" "), _c('p', {
    staticClass: "cct1",
    attrs: {
      "id": "p0005-P-26"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter29#ctn_26a",
      "id": "cnt_26a",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Conclusion")])])]), _vm._v(" "), _c('p', {
    staticClass: "cct1",
    attrs: {
      "id": "p0005-P-27"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter30#ctn_26b",
      "id": "cnt_26b",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Notes")])])]), _vm._v(" "), _c('p', {
    staticClass: "cct1",
    attrs: {
      "id": "p0005-P-28"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter31#ctn_26c",
      "id": "cnt_26c",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Acknowledgments")])])]), _vm._v(" "), _c('p', {
    staticClass: "cct1",
    attrs: {
      "id": "p0005-P-29"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter32#ctn_26d",
      "id": "cnt_26d",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("About the Author")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0faf4820","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/contents.vue
// module id = 66
// module chunks = 0